import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBqMSEZq_3dcbEAp5TNU_BYMu25TqvB3A0",
  authDomain: "ppc-authentication.firebaseapp.com",
  databaseURL: "https://ppc-authentication.firebaseio.com",
  projectId: "ppc-authentication",
  storageBucket: "ppc-authentication.appspot.com",
  messagingSenderId: "561552688217",
  appId: "1:561552688217:web:57dd2bdd583c7e4177dd48"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    console.log('main.js User is signed in')
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/v8/firebase.User
    store.dispatch("fetchUser", user);
  } else {
    console.log('main.js User is signed out')
    // User is signed out
  }
});

store.dispatch('setLoadingAppProgress', true)
store.dispatch('getNationalities');
store.dispatch('getAvailableImages');

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
